import { DashboardSidebar } from "./DashboardSidebar";
import { EmailVerificationBanner } from "./EmailVerificationBanner";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <DashboardSidebar />
      <main className="lg:pl-64">
        <div className="p-6 lg:p-8 pt-16 lg:pt-8">
          <EmailVerificationBanner />
          {children}
        </div>
      </main>
    </div>
  );
}
